import type { GlobalState } from "little-state-machine";
import type { ChatMessageType } from "../../../global.d.ts";

export function setChatHistory(
    state: GlobalState,
    payload: ChatMessageType[] | ((prevChatHistory: ChatMessageType[]) => ChatMessageType[])
): GlobalState {
    const newChatHistory =
        typeof payload === 'function' ? payload(state.chatHistory ?? []) : payload;

    return {
        ...state,
        chatHistory: newChatHistory,
    };
}
